<div class="vp-right-sidebar-dialog" [class.rs-open]="rightSidebarExpanded">
 <div id="profile_dialog" class="vp-avatar-dialog contact-dialog">
    <div class="contact__dialog-header">
    <div class="back-icon" (click)="close()" style="cursor:pointer; display:inline-flex; align-items:center;">
      <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z" fill="#000" fill-rule="evenodd"/>
      </svg>
    </div>
        <div class="header_lbl disable-select" style="margin-left: 8px;">
            {{ 'PROFILE' | translate }}
        </div>
    </div>
    <div class="contact__dialog-body user-profile-dialog" (scroll)="scrollingDialog($event)">
        <div class="content">
            <div class="parent-item">
                <div [ngStyle]="backgroundImageStyle" class="background-imge-avatar"></div>
                <div class="parent-item-user-name">
                    <div class="user-avtar">
                        <vp-avatar
                        [isHeaderAvatar]="true" [user]="{firstLastCharacters: contact?.fullName.charAt(0), jid: contact.jid, color: contact.bgAvatarColor, avatarURL: contact.avatar}">
                        </vp-avatar>
                    </div>
                    <div id="profile-user-name" class="user-name">
                        <span>
                            <div>
                                {{ contact?.fullName | titlecase}}
                            </div>
                        </span>
                        <span class="user-jid" id="user-jid" *ngIf="hasJid">
                                {{ contact?.jid }}
                        </span>
                        <span class="user-jid" id="user-jid" *ngIf="!hasJid">
                            {{ contact?.emails[0].email }}
                        </span>

                    </div>
                </div>
            <div class="profile-actions">
                <div class="profile-action-button">
                    <div matTooltip="{{ 'NEW_TICKET' | translate }}"
                        style=" z-index: 99999; justify-content: center; align-items: center; display: flex;"
                        (click)="createTicket()"
                        >
                        <ng-container [ngTemplateOutlet]="ticketIcon">
                        </ng-container>
                    </div>
                </div>
                <div class="profile-action-button">
                    <div (click)="createTask()" style="z-index: 99999;" matTooltip="{{ 'NEW_TASK' | translate }}">
                        <ng-container [ngTemplateOutlet]="taskIcon">
                        </ng-container>
                    </div>
                </div>
            </div>
            </div>

            <div class="detail-contact" *ngIf="!!contact && contact !== null" (touchstart)="swipe($event, 'start')" (touchend)="swipe($event, 'end')">
                <vnc-tabs (selected)="tabSelect($event)" [activeFirstTab]="true" >
                    <vnc-tab [id]="'contactInfo'" tabTitle="{{ 'PROFILE' | translate }}" >
                        <div class="detail-contact-tab">
                            <div class="detail-item">
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'FIRST_LAST_NAME_TITLE' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        {{ (contact.fullName) ? ((contact.fullName.length > 30) ? contact.fullName.substr(0, 30) +
                                            '...': contact.fullName): null }}
                                    </div>
                                </div>
                            </div>

                            <div class="detail-item" *ngIf="contact.company || contact.jobTitle">
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'COMPANY_JOB_POSITION' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        <span *ngIf="contact.company"> {{ contact.company }}</span>
                                        <span *ngIf="contact.company && contact.jobTitle">
                                        </span>
                                        <span *ngIf="contact.jobTitle" class="type">{{ contact.jobTitle }}</span>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="!contact.isGroup && contact.address && contact.address.length > 0">
                                <div class="detail-item" *ngFor="let address of contact.address; let i= index;">
                                    <div class="detail">
                                        <div class="lable-detail" *ngIf="i===0">
                                            {{ 'HOME_ADDRESS' | translate }}
                                        </div>
                                        <div class="detail-data">
                                            <!-- <span>
                                                {{ address.street1 }}, {{ address.city }}, {{ address.state }}
                                             </span> -->
                                             <span class="type">
                                                 {{ address.address_type }}
                                             </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.phones.length > 0">
                                <div class="detail-item" *ngFor="let phone of contact.phones; let i= index;" style="height: 38px !important;">
                                    <div class="detail" >
                                        <div class="lable-detail" *ngIf="i===0">
                                            {{ 'PHONE_MOBILE_FAX' | translate }}
                                        </div>
                                        <div class="phone-number">
                                            <span>
                                                {{ phone.phone}}
                                            </span>
                                            <span class="type" style=" height: 30px;
">
                                                {{ phone.phone_type }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.emails.length > 0">
                                <div class="detail-item" *ngFor="let email of contact.emails; let i= index;" style="height: 38px !important;">
                                    <div class="detail">
                                        <div class="lable-detail" *ngIf="i===0">
                                            {{ 'EMAILS' | translate }}
                                        </div>
                                        <div class="detail-data">
                                            <span>
                                                {{ email.email}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.urls.length > 0">
                                <div class="detail-item" *ngFor="let url of contact.urls; let i= index;">
                                    <div class="detail">
                                        <div class="lable-detail" *ngIf="i===0">
                                            {{ 'WEBSITE' | translate }}
                                        </div>
                                        <div class="detail-data">
                                            <span>
                                                {{ url.url }}
                                            </span>
                                            <span>
                                            </span>
                                            <span class="type">
                                                {{ url.url_type }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.events && contact.events.length > 0">
                                <div class="detail-item" *ngFor="let event of contact.events; let i= index;" style="height: 28px !important;     padding: 0 12px;">
                                    <div class="detail-data">
                                        <span>
                                            {{ event.event_date | date: 'M/d/yyyy' }}
                                        </span>

                                        <span class="type">
                                            {{ event.event_type }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="detail-caption-title" style="padding: 0 12px;">
                                {{ 'CONTACT_DETAILS' | translate }}
                            </div>
                            <div class="detail-item" *ngIf="contact.timezone">
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'TIME_ZONE' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        {{ contact.timezone }}
                                    </div>
                                </div>
                            </div>
                            <div class="detail-item" *ngIf="contact.language">
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'LANGUAGE_LABEL' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        {{ contact.language }}
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.skills && contact.skills.length > 0">
                                <div class="detail-item">
                                    <div class="detail list-chips">
                                        <div class="lable-detail">
                                            {{ 'SKILLS' | translate }}
                                        </div>
                                        <div>
                                            <mat-chip-list #contactChipList>
                                                <mat-chip
                                                  *ngFor="let skill of contact.skills"
                                                  [selectable]="true"
                                                  [removable]="false"
                                                  [ngStyle]="{'background': '#EAEEF2'}"
                                                  >
                                                  <span class="name" style="font-size: 12px; font-weight: 400;">{{skill.name}}</span>
                                                </mat-chip>
                                            </mat-chip-list>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div *ngIf="!contact.isGroup && contact.interests && contact.interests.length > 0">
                                <div class="detail-item">
                                    <div class="detail list-chips">
                                        <div class="lable-detail">
                                            {{ 'INTERESTS' | translate }}
                                        </div>
                                        <div>
                                            <mat-chip-list #contactChipList>
                                                <mat-chip
                                                  *ngFor="let interest of contact.interests"
                                                  [selectable]="true"
                                                  [removable]="false"
                                                  [ngStyle]="{'background': '#EAEEF2'}"
                                                  >
                                                  <span class="name" style="font-size: 12px; font-weight: 400;">{{interest.name}}</span>
                                                </mat-chip>
                                            </mat-chip-list>
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <div *ngIf="!contact.isGroup && contact.tags && contact.tags.length > 0">
                                <div class="detail-item">
                                    <div class="detail list-chips">
                                        <div class="lable-detail">
                                            {{ 'TAGS' | translate }}
                                        </div>
                                        <div>
                                            <span>
                                                <mat-chip-list #contactChipTag>
                                                    <mat-chip
                                                      *ngFor="let tag of contact.tags"
                                                      [selectable]="true"
                                                      [removable]="false"
                                                      class="tag-list-chip"
                                                      >
                                                      <span class="name">{{tag.name}}</span>
                                                    </mat-chip>
                                                </mat-chip-list>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!contact.isGroup && contact.contact_list && contact.contact_list.length > 0">
                                <div class="detail-item">
                                    <div class="detail list-chips">
                                        <div class="lable-detail">
                                            {{ 'LISTS_LBL' | translate }}
                                        </div>
                                        <div>
                                            <span>
                                                <mat-chip-list #contactChipList>
                                                    <mat-chip
                                                      *ngFor="let list of contact.contact_list"
                                                      [selectable]="true"
                                                      [removable]="false"
                                                      [ngStyle]="{'background': list.color_hex !== null ? list.color_hex : '#888888'}"
                                                      >
                                                      <span class="name">{{list.name}}</span>
                                                    </mat-chip>
                                                </mat-chip-list>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div *ngIf="!contact.isGroup && contact.notes">
                                <div class="detail-item">
                                    <div class="detail">
                                        <span>
                                            {{ contact.notes }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="detail-caption-title" *ngIf="!contact.isGroup && contact.custom_fields && contact.custom_fields.length > 0">
                                {{ 'CUSTOM_DETAILS' | translate }}
                            </div>
                            <div *ngIf="!contact.isGroup && contact.custom_fields && contact.custom_fields.length > 0">
                                <div *ngFor="let custom_field of contact.custom_fields">
                                    <div class="detail-item">
                                        <div class="detail">
                                            <div class="lable-detail">
                                                {{ custom_field.field_name }}
                                            </div>
                                            <div class="detail-data">
                                                {{ custom_field.field_value }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vnc-tab>
                    <vnc-tab [id]="'hrData'" tabTitle="{{ 'HR_DATA' | translate }}">
                        <!-- Add Content for HR Data -->
                        <div class="detail-contact-tab">
                            <div class="detail-item" *ngIf="!contact.isGroup && contact.birthday">
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'DATE_OF_BIRTH' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        {{ contact.birthday | date: "d. MMMM y"}}
                                    </div>
                                </div>
                            </div>

                            <div class="detail-item" *ngIf="!contact.isGroup && (contact.gender || contact.marital_status)">
                                <div class="detail">
                                    <div class="multi-field">
                                        <div>
                                            <div class="lable-detail">
                                                {{ 'GENDER' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.gender}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <div class="detail-item" *ngIf="!contact.isGroup && (contact.gender || contact.marital_status)">
                                <div class="detail">
                                    <div class="multi-field">
                                        <div class="margin-top-15">
                                            <div class="lable-detail">
                                                {{ 'MARITAL_STATUS' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.marital_status}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="detail-item" *ngIf="!contact.isGroup && contact.private_email">

                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'PRIVATE_EMAIL' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        {{ contact.private_email}}
                                    </div>
                                </div>
                            </div>

                            <div class="detail-item" *ngIf="!contact.isGroup && contact.vnc_employee">
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'ENGAGEMENT_TYPE' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        <span *ngIf="contact.vnc_employee === 'true'">
                                            {{ 'VNC_EMPLOYEE' | translate }}
                                        </span>
                                        <span *ngIf="contact.vnc_employee === 'false'">
                                            {{ 'NOT_VNC_EMPLOYEE' | translate }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="detail-item" *ngIf="!contact.isGroup && (contact.start_date || contact.end_date)">
                                <div class="detail">
                                    <div class="multi-field">
                                        <div *ngIf="contact.start_date">
                                            <div class="lable-detail">
                                                {{ 'START_DATE' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.start_date | date: "d. MMMM y"}}
                                            </div>
                                        </div>
                                        <div class="margin-top-15" *ngIf="contact.end_date">
                                            <div class="lable-detail">
                                                {{ 'END_DATE' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.end_date | date: "d. MMMM y"}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="detail-item" *ngIf="!contact.isGroup && (contact.per_week_availability || contact.hourly_rate || contact.payment_mode)">
                                <div class="detail" >
                                    <div class="multi-field">
                                        <div *ngIf="contact.per_week_availability">
                                            <div class="lable-detail">
                                                {{ 'PER_WEEK_AVAILABLILITY' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.per_week_availability}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="detail-item" *ngIf="!contact.isGroup && (contact.per_week_availability || contact.hourly_rate || contact.payment_mode)">
                                <div class="detail">
                                    <div class="multi-field">
                                        <div *ngIf="contact.hourly_rate" class="margin-top-15">
                                            <div class="lable-detail">
                                                {{ 'HOURLY_RATE' | translate }}
                                            </div>
                                            <div class="detail-data" >
                                                {{ contact.hourly_rate}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="detail-item" *ngIf="!contact.isGroup && (contact.per_week_availability || contact.hourly_rate || contact.payment_mode)">
                                <div class="detail">
                                    <div class="multi-field">
                                        <div *ngIf="contact.payment_mode" class="margin-top-15">
                                            <div class="lable-detail">
                                                {{ 'PAYMENT_MODE' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.payment_mode}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <div *ngIf="!contact.isGroup && contact.im_accounts && contact.im_accounts.length > 0">
                                <div class="detail-item" *ngFor="let im of contact.im_accounts; let i= index;" style="padding:  0 12px; height: 32px;">
                                    <div class="detail-data">
                                        <span>
                                            {{ im.im_id }}
                                        </span>
                                        <span>
                                        </span>
                                        <span class="type">
                                            {{ im.im_type }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="detail-item" *ngIf="!contact.isGroup && (contact.passport_number || contact.passport_expiry)">
                                <div class="detail">
                                    <div class="multi-field">
                                        <div *ngIf="contact.passport_number">
                                            <div class="lable-detail">
                                                {{ 'PASSPORT_NUMBER' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.passport_number}}
                                            </div>
                                        </div>
                                        <div *ngIf="contact.passport_expiry">
                                            <div class="lable-detail">
                                                {{ 'PASSPORT_EXPIRY' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.passport_expiry | date: "d. MMMM y"}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="detail-item" *ngIf="!contact.isGroup && (contact.national_id_number || contact.national_id_expiry)">
                                <div class="detail">
                                    <div class="multi-field">
                                        <div *ngIf="contact.national_id_number">
                                            <div class="lable-detail">
                                                {{ 'NATIONAL_ID_NUMBER' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.national_id_number}}
                                            </div>
                                        </div>
                                        <div *ngIf="contact.national_id_expiry !== null">
                                            <div class="lable-detail">
                                                {{ 'NATIONAL_ID_EXPIRY' | translate }}
                                            </div>
                                            <div class="detail-data">
                                                {{ contact.national_id_expiry | date: "d. MMMM y"}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </vnc-tab>
                    <vnc-tab [id]="'accountDetails'" tabTitle="{{ 'ACCOUNT' | translate }}" >
                        <!-- Add Content for HR Data -->
                        <div class="detail-contact-tab">
                            <div class="detail-item" *ngIf="!contact.isGroup && contact.username">
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'USER_NAME' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        {{ contact.username}}
                                    </div>
                                </div>
                            </div>
                            <div class="detail-item" *ngIf="!contact.isGroup && contact.admin">
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'ROLE_LBL' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        <span *ngIf="contact.admin === 'true'">{{ 'ADMIN' | translate }}</span>
                                        <span *ngIf="contact.admin === 'false'">{{ 'USER' | translate }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="detail-item" *ngIf="!contact.isGroup && contact.agb_accepted">
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'ACCEPTED_TERMS' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        <span *ngIf="contact.agb_accepted === 'true'">
                                            {{ 'AGB_FLAG' | translate }}
                                        </span>
                                        <span *ngIf="contact.agb_accepted === 'false'">
                                            {{ 'NOT_AGB_FLAG' | translate }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="detail-item" *ngIf="!contact.isGroup && contact.rfc_limit">
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'RFC_LIMIT' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        {{ contact.rfc_limit}}
                                    </div>
                                </div>
                            </div>

                            <div class="detail-item" *ngIf="!contact.isGroup && contact.video_bridge">
                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'VIDEO_BRIDGE' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        <span *ngIf="contact.video_bridge === 'true'">
                                            {{ 'ALLOW' | translate }}
                                        </span>
                                        <span *ngIf="contact.video_bridge === 'false'">
                                            {{ 'NOT_ALLOW' | translate }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="detail-item" *ngIf="!contact.isGroup && contact.omemo">

                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'SECURITY_ENCRYPTION' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        <span *ngIf="contact.omemo === 'true'">
                                            {{ 'OMEMO' | translate }}
                                        </span>
                                        <span *ngIf="contact.omemo === 'false'">
                                            {{ 'NOT_OMEMO' | translate }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="detail-item projects-item" *ngIf="!contact.isGroup && contact.products">

                                <div class="detail">
                                    <div class="lable-detail">
                                        {{ 'PRODUCTS' | translate }}
                                    </div>
                                    <div class="detail-data">
                                        <span *ngFor="let product of contact.products">
                                            {{ product.name }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </vnc-tab>
                </vnc-tabs>
            </div>
            <mat-menu #contactOperationMenu="matMenu">
                <button mat-menu-item (click)="editLoggedInUserDetail()">
                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-pencil"></mat-icon>
                  <span>{{ 'EDIT' | translate }}</span>
                </button>
            </mat-menu>
        </div>
    </div>
</div>
</div>

<ng-template #taskIcon>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Icon/product/task-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M16.2408997,2 C16.6460233,2 17.011119,2.24442914 17.1654729,2.6189956 L17.7645431,4.07298465 C19.6079717,4.42977883 21,6.0523266 21,8 L21,19 C21,21.209139 19.209139,23 17,23 L7,23 C4.790861,23 3,21.209139 3,19 L3,8 C3,5.98585571 4.48866491,4.31940774 6.42573635,4.04091448 L6.81051723,2.72039616 C6.93482834,2.29353144 7.32603541,2 7.77063269,2 L16.2408997,2 Z M17,6 L7,6 C5.9456382,6 5.08183488,6.81587779 5.00548574,7.85073766 L5,8 L5,19 C5,20.0543618 5.81587779,20.9181651 6.85073766,20.9945143 L7,21 L17,21 C18.0543618,21 18.9181651,20.1841222 18.9945143,19.1492623 L19,19 L19,8 C19,6.9456382 18.1841222,6.08183488 17.1492623,6.00548574 L17,6 Z M16.59,9.59 L18,11 L11,18 L6.41,13.41 L7.83,12 L11,15.17 L16.59,9.59 Z" id="Combined-Shape" fill="#8B96A0"></path>
    </g>
</svg>
</ng-template>
<ng-template #ticketIcon>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Icon/product/ticket-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M20,3 C21.1045695,3 22.0000889,3.8954305 22.0000889,5 L22.0000889,8.17067428 C21.8924018,8.20873239 21.7875364,8.25276436 21.685891,8.30237202 C20.6876727,8.78954864 20,9.81446703 20,11 C20,12.3062521 20.8348501,13.4175144 22.0000889,13.8293257 L22.0000889,17 C22.0000889,18.1045695 21.1045695,19 20,19 L4,19 C2.8954305,19 2,18.1045695 2,17 L2.00083226,13.829 C3.16558987,13.4169287 4,12.3059078 4,11 C4,9.69409219 3.16558987,8.58307131 2.00083226,8.17100001 L2,5 C2,3.8954305 2.8954305,3 4,3 L20,3 Z M20,4.99993438 L3.99999999,4.99993438 L3.99999999,6.999 L4.02440262,7.01759899 C5.18229124,7.89765805 5.92660279,9.26099004 5.994864,10.7722444 L5.99999999,11 C5.99999999,12.6014686 5.24018567,14.058339 4.02440262,14.982401 L3.99999999,14.999 L3.99999999,17 L20,17 L20,15 L19.9765611,14.9831337 C18.8181534,14.1031212 18.0734374,12.7394852 18.0051388,11.2278183 L18,11 C18,9.48239866 18.6823144,8.09467056 19.7883439,7.16713744 L20,6.999 L20,4.99993438 Z M11.5001032,7.39504181 C11.6991027,6.90392822 12.2113976,6.87026542 12.4525185,7.29663471 L12.4998236,7.39504181 L13.3320993,9.44918117 L15.4626773,9.63845901 C15.9544905,9.68210293 16.1474854,10.1497574 15.8774917,10.5166556 L15.8124895,10.5935432 L15.771712,10.6330653 L14.1534878,12.0988061 L14.6397714,14.2777191 C14.7524881,14.7831041 14.3824219,15.1209576 13.9624691,14.959173 L13.8779417,14.9200559 L11.9999634,13.7365821 L10.1689102,14.8925557 C9.7441258,15.1607265 9.32268607,14.8968084 9.34015934,14.4290621 L9.34963523,14.3328924 L9.84605779,12.0988061 L8.22821481,10.6330653 C7.85542315,10.295267 7.96137903,9.79800111 8.38616284,9.66747832 L8.48200968,9.64531434 L8.53724944,9.63845901 L10.6674463,9.44918117 L11.5001032,7.39504181 Z" id="Shape" fill="#8B96A0"></path>
    </g>
</svg>
</ng-template>